export default {
      id: "icon-twitter-usage",
      viewBox: "0 0 1200 1227",
      url: __webpack_public_path__ + "img/icons.svg#icon-twitter",
      toString: function () {
        return this.url;
      }
    }